import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyAEdYgaVoccdw6bRizWLakjuTya-Y_TvNw',
  authDomain: 'couple-game-45ccf.firebaseapp.com',
  projectId: 'couple-game-45ccf',
  storageBucket: 'couple-game-45ccf.firebasestorage.app',
  messagingSenderId: '690010598581',
  appId: '1:690010598581:web:e03b7fb5705c278ef022fc',
  measurementId: 'G-VD1BPZ9WGB',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1');

let analytics: Analytics | null = null;

export async function getFirebaseAnalytics(): Promise<Analytics | null> {
  if (analytics) return analytics;
  if (typeof window === 'undefined') return null;
  if (!(await isSupported())) return null;
  analytics = getAnalytics(app);
  return analytics;
}
